import { render } from "./DefaultContainer.vue?vue&type=template&id=285ebc91&scoped=true"
const script = {}

import "./DefaultContainer.vue?vue&type=style&index=0&id=285ebc91&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285ebc91"]])

export default __exports__